<template>
  <div v-loading="loading" class="alarmClass">
    <div style="height: 500px; overflow-y: scroll; overflow-x: hidden">
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择套餐" prop="selectCombo">
              <el-select  :disabled="model==='view'" v-model="form.selectCombo" placeholder="请选择套餐" style="width: 100%">
                <el-option
                  v-for="item in selectComboTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐费用" prop="comboFee">
              <money-input
              placeholder="请输入套餐费用" 
                 :disabled="model==='view'" v-model="form.comboFee"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>


          </el-row>
          <el-row :gutter="24">



          <el-col :span="12">
            <el-form-item label="套餐详情" prop="comboDetail">
              <el-input
              placeholder="请输入套餐详情" 
                clearable
                 :disabled="model==='view'" v-model="form.comboDetail"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="床位类型" prop="bedType">
              <el-select  :disabled="model==='view'" v-model="form.bedType" @change="bedTypeChange" placeholder="请选择床位类型" style="width: 100%">
                <el-option
                  v-for="item in bedTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>



          </el-row>
          <el-row :gutter="24">


            



          <el-col :span="12">
            <el-form-item label="是否包房" prop="isCharteredRoom">
              <el-select  :disabled="model==='view'" v-model="form.isCharteredRoom" placeholder="请选择是否包房" style="width: 100%">
                <el-option
                  v-for="item in yesNoList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费用" prop="fee">
              <money-input
              placeholder="请输入费用" 
                 :disabled="model==='view'" v-model="form.fee"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>



          </el-row>
          <el-row :gutter="24">


            


          <el-col :span="12">
            <el-form-item label="费用备注" prop="feeRemark">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.feeRemark"
                placeholder="请输入费用备注"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠后价格" prop="favorableAfterPrice">
              <money-input
              placeholder="请输入优惠后价格" 
                 :disabled="model==='view'" v-model="form.favorableAfterPrice"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          </el-row>
          <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="优惠截止日期" prop="favorableEndDate">
              <el-date-picker 
                style="width: 100%;" 
                value-format="yyyy-MM-dd HH:mm:ss" 
                 :disabled="model==='view'" v-model="form.favorableEndDate" 
                type="date" 
                placeholder="请选择优惠截止日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="床位" prop="bed">
              <!-- <el-input
                clearable
                 :disabled="model==='view'" v-model="form.bed"
                placeholder="请输入床位"
                maxlength="20"
              ></el-input> -->
              
                <el-select
                style="width:100%;"
                 :disabled="model==='view'" 
                  v-model="form.bed"
                  :value="form.bed"
                  placeholder="请选择 服务地点"
                  clearable
                  ref="addConnectSelect"
                  @change="bedIdChange"
                >
                  <el-option
                    :value="form.bed"
                    show-all-levels
                    :label="form.benName"
                  >
                    <el-tree

                      :props="treeProps"
                      :load="editAreaLazyLoadTree"
                      lazy
                      @node-click="editAreaNodeTreeClick_"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>


          </el-row>
          <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="床位描述" prop="bedDescription">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.bedDescription"
                placeholder="请输入床位描述"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
  <script>
import { getStore } from '@/util/store';
import { getDictionary } from '@/api/common.js';

  import { treeListDetail, saveCateringBedInfo, getCateringBedDetail, getBedTypeList, treeNursingList
} from '../api/serveItemManage';
export default {
  components: {},
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      
      // 树的节点属性
      treeProps: {
        label: 'name',
        value: "id",
        isLeaf: (data) => {
          console.log('data=======',data.nextType,this.leafType,data);
          return data.nextType == this.leafType;
        },
      },
      leafType: -1, 
      // treeProps: {
      //   //标题
      //   label: "name",
      //   //值
      //   value: "id",
      //   //子节点
      //   children: "zones",
      //   //是否叶子节点
      //   isLeaf: "nextType",
      //   //本节点类型key值
      //   objectType: "id",
      //   //本节点类型名
      //   objectTypeName: "name",
      // },
      projectList: [],
      form: {
        name: '',
      },
      tempType: 0,
      formRules: {
        selectCombo: [{ required: true, message: '套餐不能为空', trigger: 'blur' }],
        bed: [{ required: true, message: '床位不能为空', trigger: 'change' }],
      },
      matetialList: [],
      selectComboTypeList: [],
      bedTypeList: [],
      yesNoList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    
    // 树加载完毕
    editAreaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        return resolve([{ name: this.row.nursinghomeName , id: this.nursinghomeId, nextType:this.tempType,}]);
      } else {
        id = node.data.id;
      }
      console.log(node.data,node,"node.data=====>");
      if (node.level === 5) {
        resolve({});
        return;
      }
      // if(node.data.nextType==-1){
      //   return;
      // }
      console.log(node.data,"node.data=====>");
      // this.tempType = this.tempType + 1
      
      treeNursingList({ parentId: id, type: node.level }).then(
        ({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.nextType = !item.nextType;
            });
          } else {
          }
          resolve(data);
        }
      );
    },
    editAreaNodeTreeClick_(node) {
      setTimeout(() => {
        console.log(node);
        if (parseInt(node.nodeType) == 1) {
          // this.$message.error();
          return;
        }
        let nodeId = node.id;
        let nodeTitle = node.name;
        // this.addForm.requireMainId = "";
        // this.form = Object.assign({}, this.form, {
        //   benName: nodeTitle,
        //   bed: nodeId,
        // });
        treeListDetail({id:nodeId}).then(res=>{
          this.form.benName = res.data.name;
          this.form.bed = res.data.id;
          this.form = this._.cloneDeep(this.form);
          if(res.data.name){
            this.$refs.addConnectSelect.blur();
          }
        })
        // this.areaNameFlag = true;
        // this.areaIdFlag = false;
      }, 0);
    },
    bedTypeChange(val){
      this.bedTypeList.forEach(ele=>{
        if(val === ele.id){
          this.form.fee = ele.bedPrice
        }
      })
    },
    async initData() {
      
      treeNursingList({ parentId: this.nursinghomeId, type: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.nextType = !item.nextType;
          });
        }
        console.log(this.treeFormAreaData);
        this.treeFormAreaData = data;
      });
      // getDictionary('nursinghome_select_combo_type').then((res) => {
      //   this.selectComboTypeList = res.data;
      // });
      // getDictionary('nursinghome_bed_type').then((res) => {
      //   this.bedTypeList = res.data;
      // });
      getBedTypeList().then((res)=>{
        this.bedTypeList = res.data;
      })
      getDictionary('yes_no').then((res) => {
        this.yesNoList = res.data;
      });
      if(getStore({name:'elderId'})){
        getCateringBedDetail({elderlyId: getStore({name:'elderId'})}).then((res)=>{
          this.form = res.data;
          console.log(this.form);
          this.form = this._.cloneDeep(this.form);
        });
      }
      
      if (this.model == 'add') {
      } else {
      }
    },
    saveRecord(cb) {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
        
        if(result){
            saveCateringBedInfo({elderlyId:getStore({name:'elderId'}),...this.form}).then((res)=>{
              this.$message.success('操作成功！');
              this.$emit('success', this.form);
            if(cb)cb();
            });
        }
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  